import type { AnimationCanvasProps } from '@suntex.core/animation';

import { PlayerBadge as initPlayerBadgeGraphics } from '../createjs/PlayerBadge';

/** `AnimationCanvas` props that load the PlayerBadge Animate library. */
export const playerBadgeComposition = {
  compositionId: 'B8DEB2847161C640B28373DD93571676',
  transformImageSource: (src) => fimCdnAnimateUrl(src),
  initGraphics: (cjs, an) => {
    initPlayerBadgeGraphics(cjs, an);
  },
} satisfies Pick<
  AnimationCanvasProps,
  'compositionId' | 'transformImageSource' | 'initGraphics'
>;

function fimCdnAnimateUrl(src: string): string {
  src = src.trim().replace(/^\//, '');
  return `https://cdn.firstinmath.com/content/animate/live/${src}`;
}
